"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

require("./tabs.less");

var Tabs = function (_super) {
  __extends(Tabs, _super);

  function Tabs(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      activeIndex: props.activeIndex || 0
    };
    return _this;
  }

  Tabs.prototype.render = function () {
    var _this = this;

    var activeItem = undefined;
    var activeIndex = this.state.activeIndex;
    var childrenWithProps = React.Children.map(this.props.children, function (item, index) {
      if (index === activeIndex) {
        activeItem = item;
      }

      return React.cloneElement(item, {
        active: index === activeIndex,
        onClick: function onClick(event) {
          return _this.setState({
            activeIndex: index
          });
        }
      });
    });
    var classNames = ["tabs"];

    if (this.props.centered) {
      classNames.push("centered");
      classNames.push("text-center");
    }

    if (this.props.borderless) {
      classNames.push("borderless");
    }

    return React.createElement("div", {
      className: "tabs-container"
    }, React.createElement("ul", {
      className: classNames.join(" ")
    }, childrenWithProps), React.createElement("div", {
      className: "content"
    }, activeItem.props.children));
  };

  return Tabs;
}(React.Component);

exports["default"] = Tabs;

function TabItem(props) {
  var classNames = [];

  if (props.active) {
    classNames.push("active");
  }

  if (props.borderless) {
    classNames.push("borderless");
  }

  var icon = "";

  if (props.icon) {
    icon = React.createElement("i", {
      className: "icon icon--sm block icon-" + props.icon
    });
  }

  return React.createElement("li", {
    className: classNames.join(" "),
    onClick: props.onClick
  }, React.createElement("div", {
    className: "tab__title"
  }, icon, React.createElement("span", null, props.title)));
}

exports.TabItem = TabItem;